import React, { useState, useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import './style.css';
import Footer from 'components/Footer/Footer';
import {
  managed_contents,
  user_access_level,
  myHeaders_With_Cache_Control
} from 'Api/Api';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import axios from 'axios';
import home from 'Assets/home.svg';
// import { ReactTypeformEmbed } from 'react-typeform-embed';
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { UploadAsset } from 'Api/UploadAsset';
import UserContext from 'store/UserContext';
import { get_current_unix_stamp } from 'utils/Helper';

import HubspotForm from 'react-hubspot-form';

const hubspot_portalId = '6817434';
const hubspot_formId = '689dadb1-8a7b-44c1-b9f8-bea31e54b6fa';

function Press() {
  const [api_data, set_api_data] = useState();
  const [press_data_obj, set_press_data_obj] = useState();
  const [pressKey, setPressKey] = useState('');
  const [newsKey, setNewsKey] = useState('');
  const [news_data_obj, set_news_data_obj] = useState();
  const [loading, set_loading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [showPressEdit, setShowPressEdit] = useState(false);
  const [showNewsEdit, setShowNewsEdit] = useState(false);
  const [newsTitle, setNewsTitle] = useState('');
  const [newsDesc, setNewsDesc] = useState('');
  const [newsLink, setNewsLink] = useState('');
  const [newsImage, setNewsImage] = useState('');
  const [newsContent, setNewsContent] = useState('');
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  const [saving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [assetConfig, setAssetConfig] = useState();
  const user_context = useContext(UserContext);


  //captures values of the job field for adding
  const handleNewsTitleTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setNewsTitle(e.target.value);
  };
  const handleNewsDescTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setNewsDesc(e.target.value);
  };
  const handleNewsLinkTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setNewsLink(e.target.value);
  };
  const handleNewsContentTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setNewsContent(e.target.value);
  };

  // Press API Function GETS ALL DATA
  async function PressAPI() {
    const response = await axios.get(
      `${managed_contents}/press`,
      user_access_level === 'admin' ? myHeaders_With_Cache_Control : null
    );
    console.log('*****NEW DATA******', response.data);
    const press_res = response.data;
    set_api_data(press_res);
    
    // JBB - we want to store press_data as an Object/map, not an array. Tricky to sort, but I'll show you how.
    /*
    let tmp_press_data_arr = [];
    for (let content_section_name of Object.keys(press_res.content_sections)) {
      if (content_section_name.startsWith('press_section_')) {
        // tmp_press_data_obj[content_section_name] =
        //   press_res.content_sections[content_section_name];
        tmp_press_data_arr.push(
          press_res.content_sections[content_section_name]
        );
      }
    }
    tmp_press_data_arr = tmp_press_data_arr.sort((a, b) => {
      if (a.display_time < b.display_time) {
        return 1;
      } else if (a.display_time > b.display_time) {
        return -1;
      }
      return 0;
    });
    console.log('!!!!!!PRESS data!!!!!', tmp_press_data_arr);
    let tmp_recent_news_obj = {};
    for (let content_section_name of Object.keys(press_res.content_sections)) {
      if (content_section_name.startsWith('recent_news_')) {
        tmp_recent_news_obj[content_section_name] =
          press_res.content_sections[content_section_name];
      }
    }
    console.log('!!!!!!NEWS data!!!!!', tmp_recent_news_obj);
    */
    // JBB - use one loop to separate the data
    let tmp_press_data_obj = {};
    let tmp_recent_news_obj = {};
    for (let content_section_name of Object.keys(press_res.content_sections)) {
      if (content_section_name.startsWith('recent_news_')) {
        tmp_recent_news_obj[content_section_name] =
          press_res.content_sections[content_section_name];
          // JBB let's also massage images to a good size - 350x100. ADd a new field for it to differentiate between what is in the database and what is being used to display.
          //   We should really make this a Helper function.
          if (tmp_recent_news_obj[content_section_name].image_url) {
            let array = tmp_recent_news_obj[content_section_name].image_url.split("/");
            tmp_recent_news_obj[content_section_name].adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padtransparent_320x100/${array[5]}`;
          }
      } else if (content_section_name.startsWith('press_section_')) {
        tmp_press_data_obj[content_section_name] =
          press_res.content_sections[content_section_name];
      }        
    }
    
    // JBB - now sort the news objects by display_time. Javascript does not make this easy.
    tmp_press_data_obj = Object.fromEntries(Object.entries(tmp_press_data_obj).sort((a,b) => b[1].display_time - a[1].display_time));

    // news content api data
    set_news_data_obj(tmp_recent_news_obj);
    // press content api data
    //set_press_data_obj(tmp_press_data_arr);
    set_press_data_obj(tmp_press_data_obj);
    set_loading(false);
    return;
  }

  useEffect(() => {
    if (!press_data_obj && !news_data_obj) {
      (async () => {
        try {
          await PressAPI();
        } catch (err) {
          set_loading(false);
          console.log('Something went wrong', err);
        }
      })();
    }
  });

  /**
   * The following is for PRESS_SECTION
   */

  //This is the API call to SUBMIT a PRESS_SECTION
  async function handleSubmitPress() {
    const unixTime = Math.floor(selectedDate.getTime() / 1000); // JBB should always Math.floor this so you ensure an integer is going into the database.
    //const newPressKey = `press_section_${unixTime}`; // JBB should be using current unix stamp for content_sections key
    const newPressKey = `press_section_${get_current_unix_stamp()}`;

    //setup patch for adding new press with validation
    if (newsLink < 1 || newsDesc < 1 || newsTitle < 1) {
      setMessage(
        <span style={{ color: 'red' }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else {
      let newsAddPatch = {
        content_sections: {
          [newPressKey]: {
            display_time: unixTime,
            link_url: newsLink,
            link_text: newsDesc,
            title: newsTitle
          }
        }
      };
      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${managed_contents}/${api_data.entity_uuid}`,
        newsAddPatch
      );
      await PressAPI();
    }

    handleCloseAdd();
    setSaving(false);
    console.log('***** ADDED PRESS *****');
  }

  //This is the API call to UPDATE a PRESS_SECTION
  async function updatePressData(pressSectionKey) {
    const unixTime = Math.floor(selectedDate.getTime() / 1000); // JBB should always Math.floor this so you ensure an integer is going into the database.
    if (newsLink < 1 || newsDesc < 1 || newsTitle < 1) {
      setMessage(
        <span style={{ color: 'red' }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else {
      let pressEditPatch = {
        content_sections: {
          [pressSectionKey]: {
            display_time: unixTime,
            link_url: newsLink,
            link_text: newsDesc,
            title: newsTitle
          }
        }
      };
      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${managed_contents}/${api_data.entity_uuid}`,
        pressEditPatch
      );
      console.log('Press Edit Patch', pressEditPatch);
      await PressAPI();
      handleClosePressEdit();
      console.log('$$$$$$$ UPDATE PRESS SECTION $$$$$$$');
    }
  }

  //This is the api call to DELETE the PRESS article
  async function deletePressData(pressSectionKey) {
    //setup patch
    let pressDeletePatch = {
      content_sections: {
        [pressSectionKey]: {}
      }
    };
    await axios.patch(
      `${managed_contents}/${api_data.entity_uuid}`,
      pressDeletePatch
    );
    await PressAPI();
    setShowPressEdit(false);
    console.log('$$$$$$$ DELETED PRESS ########');
  }

  /**
   *
   *
   * The following is for RECENT_NEWS
   */

  //This is the API call to UPDATE a RECENT_NEWS
  async function updateNewsData(newsSectionKey) {
    if (
      newsLink < 1 ||
      newsDesc < 1 ||
      newsTitle < 1 ||
      newsContent < 1 ||
      newsImage < 1
    ) {
      setMessage(
        <span style={{ color: 'red' }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else if (assetConfig) {
      let image_url = await UploadAsset(assetConfig);
      let newsEditPatch = {
        content_sections: {
          [newsSectionKey]: {
            html_content: newsContent,
            image_url: image_url,
            link_url: newsLink,
            link_text: newsDesc,
            title: newsTitle
          }
        }
      };

      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${managed_contents}/${api_data.entity_uuid}`,
        newsEditPatch
      );
      await PressAPI();
      handleCloseNewsEdit();
      setSaving(false);
      console.log('$$$$$$$ UPDATE NEWS SECTION w/Image $$$$$$$');
    } else {
      let newsEditPatch = {
        content_sections: {
          [newsSectionKey]: {
            html_content: newsContent,
            image_url: newsImage,
            link_url: newsLink,
            link_text: newsDesc,
            title: newsTitle
          }
        }
      };

      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${managed_contents}/${api_data.entity_uuid}`,
        newsEditPatch
      );
      await PressAPI();
      handleCloseNewsEdit();
      setSaving(false);
      console.log('$$$$$$$ UPDATE NEWS SECTION w/o Image $$$$$$$');
    }
  }

  let fileObj = {}; // HTML "File" object you get from <Form.File> component
  function onChangeFile(event) {
    fileObj = event.target.files[0]; // HTML "File" object you get from <Form.File> component
    let upload_asset_config = {
      asset_data: fileObj, // HTML "File" object you get from <Form.File> component
      entity_type: 'managed_contents',
      entity_uuid: api_data.entity_uuid,
      asset_type: 'images',
      onProgressDisplayUpdate: (message) => setMessage(message)
    };
    setAssetConfig(upload_asset_config);
    // JBB - need to update newsImage so user sees the filename in form
    setNewsImage(event.target.files[0].name);
  }

  //For ADDING to PRESS
  const handleShowAdd = () => {
    setSelectedDate('');
    setShowAdd(true);
  };
  const handleCloseAdd = () => {
    setValidated(false);
    setMessage(<span>&nbsp;</span>);
    setNewsTitle('');
    setNewsDesc('');
    setNewsLink('');
    setShowAdd(false);
  };

  //EDITING PRESS
  // JBB - incorrect handling of pressKey - it is not related to display_time
  const handleShowPressEdit = (pressData, pressSectionKey) => {
    setShowPressEdit(true);
    setNewsTitle(pressData.title);
    setNewsDesc(pressData.link_text);
    setNewsLink(pressData.link_url);
    setSelectedDate(handleEditDate(pressData.display_time));
    //setPressKey(`press_section_${pressData.display_time}`); // JBB - use key here, not display time
    setPressKey(pressSectionKey);
  };
  const handleClosePressEdit = () => {
    setValidated(false);
    setSaving(false);
    setMessage(<span>&nbsp;</span>);
    setNewsTitle('');
    setNewsDesc('');
    setNewsLink('');
    setShowPressEdit(false);
  };

  //EDITING NEWS
  const handleShowNewsEdit = (newsData, newsSectionKey) => {
    setShowNewsEdit(true);
    setNewsTitle(newsData.title);
    setNewsDesc(newsData.link_text);
    setNewsLink(newsData.link_url);
    setNewsImage(newsData.image_url);
    setNewsContent(newsData.html_content);
    setNewsKey(newsSectionKey);
    setAssetConfig(null); // JBB - need to do this to cancel out any previous onChangeFile stuff
  };
  const handleCloseNewsEdit = () => {
    setValidated(false);
    setMessage(<span>&nbsp;</span>);
    setNewsTitle('');
    setNewsDesc('');
    setNewsLink('');
    setShowNewsEdit(false);
  };

  //DATE STUFF
  const displayPrettyDate = (timeData) => {
    let prettyDate = moment.unix(timeData).format('MMMM Do YYYY');
    return prettyDate;
  };
  const handleEditDate = (timeData) => {
    let editableDate = moment.unix(timeData).toDate();
    return editableDate;
  };

  const responsiveTheme =
  user_context.theme === 'light'
    ? { backgroundColor: 'white', color: 'black' }
    : { backgroundColor: 'rgb(25,25,25)', color: 'white' };

  return (
    <>
      {loading ? (
        <ActivityIndicator theme="spinner" />
      ) : (
        <>
          <Helmet defer={false}>
            <title>PechaKucha In The News</title>
            <meta name="description" content="PechaKucha In The News" />
            <meta property="og:type" content="website" />
            <meta
              property="og:url"
              content="https://www.pechakucha.com/press"
            />
            <meta property="og:title" content="PechaKucha In The News" />
            <meta property="og:description" content="PechaKucha In the News" />
          </Helmet>
          <div className="press">
            {/* Recent News Section Starts */}
            <div className="pad-top50 pad-bot100">
              <>
                <div className="container">
                  <div className="recentNews">
                    <Row>
                      <Col lg={12}>
                        <h1>PechaKucha in the News</h1>
                      </Col>
                    </Row>
                    <Row>
                      {Object.keys(news_data_obj).map((item, index) => (
                        <React.Fragment key={index}>
                          <Col lg={4} md={4} sm={12}>
                            {user_access_level === 'admin' && (
                              <Button
                                className="mx-2"
                                style={{ maxHeight: '40px' }}
                                // onClick={handleShowNewsEdit}
                                onClick={() =>
                                  handleShowNewsEdit(news_data_obj[item], item)
                                }>
                                Edit
                              </Button>
                            )}
                            <div className="logoImg">
                              <img
                                src={news_data_obj[item].adjusted_image_url}
                                className="img-fluid img-news"
                                alt="{item.title}"
                              />
                            </div>
                            <p>{news_data_obj[item].html_content}</p>
                            <a
                              rel="nofollow noopener noreferrer"
                              target="_blank"
                              href={news_data_obj[item].link_url}>
                              {news_data_obj[item].link_text}
                            </a>
                          </Col>
                        </React.Fragment>
                      ))}
                    </Row>
                  </div>
                </div>
              </>
            </div>
            {/* Recent News Section ends */}

            {/* News Section Starts */}
            <div className="bg-grey pad100" style={responsiveTheme}>
              <>
                <div className="container">
                  <div className="news">
                    <Row >
                      <Col lg={12}>
                        <div className="newsHead">
                          <h1 >More News...</h1>
                          <p>PechaKucha makes software as easy as 1-2-3</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      {user_access_level === 'admin' && (
                        <Button
                          className="mx-2 ml-auto"
                          style={{ maxHeight: '40px' }}
                          onClick={handleShowAdd}>
                          Add New +
                        </Button>
                      )}
                      
                      {/* // JBB - remember we want both the key and the value from this map. Use Object.keys or Object.entries to accomplish.
                      {press_data_obj.map((item, index) => (
                        <React.Fragment key={index}>
                          <Col lg={12} md={12} sm={12} key={index}>
                            <div className="newsLinks">
                              <div className="pressContent">
                                <h5>{item.title}</h5>
                                <p>{displayPrettyDate(item.display_time)}</p>
                                <a
                                  rel="nofollow noopener noreferrer"
                                  target="_blank"
                                  href={item.link_url}>
                                  {item.link_text}
                                </a>
                              </div>
                              {user_access_level === 'admin' && (
                                <Button
                                  style={{ maxHeight: '40px' }}
                                  onClick={() => handleShowPressEdit(item)}>
                                  Edit
                                </Button>
                              )}
                            </div>
                          </Col>
                        </React.Fragment>
                      ))}
                      */}
                      {Object.entries(press_data_obj).map(([tmp_pressDataKey,item]) => (
                        <React.Fragment key={tmp_pressDataKey}>
                          <Col lg={12} md={12} sm={12} key={tmp_pressDataKey} >
                            <div className="newsLinks">
                              <div className="pressContent">
                                <h5>{item.title}</h5>
                                <p>{displayPrettyDate(item.display_time)}</p>
                                <a
                                  rel="nofollow noopener noreferrer"
                                  target="_blank"
                                  href={item.link_url}>
                                  {item.link_text}
                                </a>
                              </div>
                              {user_access_level === 'admin' && (
                                <Button
                                  style={{ maxHeight: '40px' }}
                                  onClick={() => handleShowPressEdit(item,tmp_pressDataKey)}>
                                  Edit
                                </Button>
                              )}
                            </div>
                          </Col>
                        </React.Fragment>
                      ))}
                    </Row>
                  </div>
                </div>
              </>
            </div>
            {/* News Section Ends */}
                <section>
                    <div className="container">
                      <Row style={{ marginBottom: "10px", marginTop: "40px", minHeight: "200px" }} className="">
                        <Col xs={12} md={6}>
                          <p style={{ fontSize: "200%" }}>Have a question about PechaKucha?</p>
                          <p style={{ marginBottom: "5px" }}>Check out our FAQs, or use this form to request more information about PechaKucha!</p>
                          <a target="_blank" rel="noopener noreferrer" href="https://pechakucha.zendesk.com/hc/en-us/categories/360002876531-PechaKucha-com-PK-Create-">
                            <Button
                              variant="pkprimary"
                            >
                              See FAQs
                            </Button>
                          </a>
            
                        </Col>
                        <Col xs={12} md={6} style={{ backgroundColor: "lightgray", paddingTop: "10px" }}>
                          <HubspotForm
                            portalId={hubspot_portalId}
                            formId={hubspot_formId}
                            onSubmit={() => console.log('Submit!')}
                            onReady={(form) => console.log('Form ready!')}
                            loading={<div>Loading...</div>}
                          />
                        </Col>
                      </Row>
                      {/*
                        <Row>
                            <Col lg={12}>
                                <div className="form-head">
                                    <h1>Fill-out the form below to get more information about PechaKucha, including pricing:</h1>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <div className="school-formdetails" id="typeForm">
                                        <ReactTypeformEmbed url="https://pechakucha.typeform.com/to/PI9ZZ2" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                      */}
                    </div>
                </section>

            <Footer homeImg={home} homeImgRef="/" breadcrumbSubPage="Press" />
          </div>
          {/* This modal ADDS a News Article */}
          <Modal show={showAdd} onHide={handleCloseAdd}>
            <Modal.Header closeButton style={responsiveTheme}>
              <Modal.Title >Add News</Modal.Title>
            </Modal.Header>
            <Modal.Body style={responsiveTheme}>
              <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="newsTitle">
                  <Form.Label>News Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter News Title"
                    onChange={handleNewsTitleTyping}
                    //className={jobTitle.length < 1 ? 'is-invalid' : 'is-valid'}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="newsDescription">
                  <Form.Label>News Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Enter News Description"
                    onChange={handleNewsDescTyping}
                    //className={jobDesc.length < 1 ? 'is-invalid' : 'is-valid'}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="newsLink">
                  <Form.Label>News Link</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter News Link"
                    onChange={handleNewsLinkTyping}
                    //className={jobLink.length < 1 ? 'is-invalid' : 'is-valid'}
                    required
                    disabled={saving}
                  />
                </Form.Group>
                <Form.Group controlId="newsLink">
                  <Form.Label>Release Date</Form.Label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    placeholderText="Select A Date"
                    required
                    disabled={saving}
                  />
                </Form.Group>
              </Form>
              {message}
            </Modal.Body>
            <Modal.Footer style={responsiveTheme}>
              <Button variant="secondary" onClick={handleCloseAdd}>
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={handleSubmitPress}>
                Save News
              </Button>
            </Modal.Footer>
          </Modal>

          {/* this modal EDITS a PRESS Article */}
          <Modal show={showPressEdit} onHide={handleClosePressEdit}>
            <Modal.Header closeButton style={responsiveTheme}>
              <Modal.Title>
                Edit Press Article
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={responsiveTheme}>
              <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="newsTitle">
                  <Form.Label>News Title</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleNewsTitleTyping}
                    defaultValue={newsTitle}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="newsDescription">
                  <Form.Label>News Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    onChange={handleNewsDescTyping}
                    defaultValue={newsDesc}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="newsLink">
                  <Form.Label>News Link</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleNewsLinkTyping}
                    defaultValue={newsLink}
                    required
                    disabled={saving}
                  />
                </Form.Group>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  placeholderText="Select A Date"
                  required
                  disabled={saving}
                />
              </Form>
              {message}
            </Modal.Body>
            <Modal.Footer className="d-flex" style={responsiveTheme}>
              <Button
                variant="danger"
                className="mr-auto"
                onClick={() => deletePressData(pressKey)}>
                Delete
              </Button>
              <Button variant="secondary" onClick={handleClosePressEdit}>
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={() => updatePressData(pressKey)}>
                Update News
              </Button>
            </Modal.Footer>
          </Modal>

          {/* this modal EDITS a NEWS Article */}
          <Modal show={showNewsEdit} onHide={handleCloseNewsEdit}>
            <Modal.Header closeButton style={responsiveTheme}>
              <Modal.Title>
                Edit Recent News
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={responsiveTheme}>
              <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="newsTitle">
                  <Form.Label>News Title</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleNewsTitleTyping}
                    defaultValue={newsTitle}
                    //className={jobTitle.length < 1 ? 'is-invalid' : 'is-valid'}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="htmlContent">
                  <Form.Label>News Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    onChange={handleNewsContentTyping}
                    defaultValue={newsContent}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="linkText">
                  <Form.Label>Link Text</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleNewsDescTyping}
                    defaultValue={newsDesc}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group controlId="newsLink">
                  <Form.Label>News Link</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleNewsLinkTyping}
                    defaultValue={newsLink}
                    //className={jobLink.length < 1 ? 'is-invalid' : 'is-valid'}
                    required
                    disabled={saving}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Image (16:9 aspect ratio recommended)</Form.Label>
                  <Form.File id="custom-file" custom={true}>
                    <Form.File.Label>
                      {newsImage ? newsImage.split('/').pop() : 'Click to Upload Image File'}
                    </Form.File.Label>
                    <Form.File.Input
                      accept=".jpg,.jpeg,.png,.gif"
                      disabled={saving}
                      onChange={onChangeFile}
                      //required // JBB - this will always show an error while editing. There are ways around this but they are unnecessarily complex so we won't use HTML validation here.
                    />
                    <Form.Control.Feedback type="invalid">
                      Please select an image
                    </Form.Control.Feedback>
                  </Form.File>
                </Form.Group>
              </Form>
              {message}
            </Modal.Body>
            <Modal.Footer className="d-flex" style={responsiveTheme}>
              <Button variant="secondary" onClick={handleCloseNewsEdit}>
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={() => updateNewsData(newsKey)}>
                Update News
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
}

export default Press;
